import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle";
import { DataSender } from '../loaders'
import { Validation, FormValidationRules, FormValidation } from '../validation/validation';

/**
* BillingInformationModal
*/

class BillingInformationModal {
    constructor(target, eventId, callback) {
        if(!target || !target.length || !eventId) {
            window.activeModalInstance = null;
            return;
        }

        this.target = target;
        this.callback = (callback) ? callback : null;
        this.eventId = eventId;
        this.texts = {};
        this.timeout = null;

        this.loadModal();
    }

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        this.target.show();

        new DataSender({
            data: { id: this.eventId },
            url: '/event/tickets/billing/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);
                    that.texts = window.billingInformationModalTexts;

                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        this.header = this.target.find('.modal-header');
        this.header.find('button').bind('click', function() {
            that.closeModal();
        });

        this.form = this.target.find('form');
        this.form.bind("submit", function (event) {
            event.preventDefault();
        });

        var tooltipTriggerList = [].slice.call($('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));

        var companyName = this.form.find('input[name="company_name"]');
        var companyFRP = this.form.find('input[name="company_frp"]');
        var companyUIC = this.form.find('input[name="company_uic"]');
        var companyVAT = this.form.find('input[name="company_vat"]');
        var companyVATNumber = this.form.find('input[name="company_vat_number"]');
        var companyCountry = this.form.find('select[name="company_country"]');
        var companyCity = this.form.find('input[name="company_city"]');
        var companyPostal = this.form.find('input[name="company_postal"]');
        var companyStreet = this.form.find('input[name="company_street"]');
        var bankName = this.form.find('input[name="bank_name"]');
        var bankAddress = this.form.find('input[name="bank_address"]');
        var bankIBAN = this.form.find('input[name="bank_iban"]');
        var bankBIC = this.form.find('input[name="bank_bic"]');
        var contactEmail = this.form.find('input[name="contact_email"]');
        var contactPhone = this.form.find('input[name="contact_phone"]');
        var submitButton = this.form.find('button');

        // VAT:
            companyVAT.bind('change', function() {
                if(companyVAT.is(':checked')) {
                    companyVAT.parent().addClass('checked');
                    companyVATNumber.val('').focus();
                }
                else {
                    companyVAT.parent().removeClass('checked');
                    companyVATNumber.val('').removeHighlight();
                }
            });

            (companyVAT.is(':checked')) ? companyVAT.parent().addClass('checked') : companyVAT.parent().removeClass('checked');

        // Validation:
            var fv = new FormValidation(this.form);

            fv.addRule(companyName, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.companyNameError);
            fv.addRule(companyFRP, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.frpError);
            fv.addRule(companyUIC, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.uicError);
            fv.addRule(companyVATNumber, function(value) { return (companyVAT.is(':checked')) ? FormValidationRules.LENGTH_IN_RANGE(value, { min: 1, max: 100}) : true; }, null, this.texts.vatNumberError);
            fv.addRule(companyCountry, function(value) { return (parseInt(value) != 0); }, null, this.texts.countryError);
            fv.addRule(companyCity, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.cityError);
            fv.addRule(companyPostal, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.postalError);
            fv.addRule(companyStreet, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.streetError);
            fv.addRule(bankName, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.bankNameError);
            fv.addRule(bankIBAN, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.bankIBANError);
            fv.addRule(bankBIC, 'LENGTH_IN_RANGE', { min: 1, max: 100 }, this.texts.bankBICError);
            fv.addRule(contactEmail, 'VALID_EMAIL', null, this.texts.emailError);

            fv.errorsHandler = function(errors) {
                for(var i in errors) {
                    switch(errors[i].target.prop('name')) {
                        case 'company_name':
                        case 'company_frp':
                        case 'company_uic':
                        case 'bank_name':
                        case 'bank_iban':
                        case 'bank_bic':
                            errors[i].target.highlight('red', { hideEvent: 'input', placement: 'left', text: errors[i].error });
                            break;

                        case 'company_vat_number':
                            errors[i].target.highlight('red', { hideEvent: 'input', offset: [-33, 0], placement: 'left', text: errors[i].error });
                            break;

                        case 'company_country':
                            errors[i].target.highlight('red', { hideEvent: 'mouseover', placement: 'right', text: errors[i].error });
                            break;

                        case 'company_city':
                        case 'company_postal':
                        case 'company_street':
                        case 'contact_email':
                            errors[i].target.highlight('red', { hideEvent: 'input', placement: 'right', text: errors[i].error });
                            break;
                    }

                    errors[i].target.focus();
                    break;
                }
            };

            fv.successHandler = function() {
                window.clearTimeout(that.timeout);
                submitButton.html('<div class="activity-indicator"></div>');

                new DataSender({
                    data: {
                        id: that.eventId,
                        form_data: that.form.serializeObject()
                    },
                    url: '/event/tickets/billing/save/',

                    success: function(data) {
                        if(data.status) {
                            that.timeout = window.setTimeout(function() {
                                submitButton.addClass('success').html(submitButton.data('saved'));

                                that.timeout = window.setTimeout(function() {
                                    submitButton.removeClass('success').html(submitButton.data('save'));
                                }, 1500);
                            }, 100);
                        }
                        else {
                            submitButton.html(submitButton.data('save')).highlight('red', { hideEvent: 'mouseout', text: data.message });
                        }
                    }
                });
            };
    }

    closeModal() {
        this.target.hide();
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();

        if(this.callback) {
            if(this.success) {
                this.callback({ success: true });
            }
            else {
                this.callback({ success: false });
            }
        }

        window.activeModalInstance = null;
    }
}

export { BillingInformationModal }
